/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProjectToAddInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Project
   * @summary Создать проект.
   * @request POST:/bff/Project/CreateProject
   * @secure
   */
  projectCreateProject = (data: ProjectToAddInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/bff/Project/CreateProject`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Получение общего размера проекта.
   * @request GET:/bff/Project/{projectId}/ProjectSize
   * @secure
   */
  projectGetProjectSize = (projectId: string, params: RequestParams = {}) =>
    this.http.request<number, any>({
      path: `/bff/Project/${projectId}/ProjectSize`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
